import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core'
import { UserService } from '@ui-core/services/user.service'
import { Heading } from '@ui-shared/ui/heading/heading'
import { ButtonModule } from 'primeng/button'
import { Support } from '../support/support'

@Component({
    selector: 'app-error-full-page',
    imports: [Heading, ButtonModule, Support],
    templateUrl: './error-full-page.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ErrorFullPage {
    private userService = inject(UserService)

    title = input<string>('')
    message = input<string>('')

    logout(): void {
        this.userService.setLogout(true)
    }
}
